module.exports = __webpack_public_path__ + "img/img43.ab1ec112.svg";